module.exports = __webpack_public_path__ + "static/img/CA.76a934a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/countryFlag/CA.svg
// module id = nAou
// module chunks = 66